export default __webpack_public_path__ + "static/media/delegateCash.e5bdf79d.svg";